import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import trainerImg from "../assets/img/trainer.jpg";
import groupImg from "../assets/img/trainer_threekids_medals.jpeg";
import onlineImg from "../assets/img/reverse_handstand.jpeg";

export const Home = () => {
  const { t } = useLanguage();

  return (
    <div className="page page-home">
      <section className="home-hero">
        <div className="home-hero-inner">
          <span className="kicker">{t.home.kicker}</span>
          <h1>{t.home.name}</h1>
          <p className="home-credentials">{t.home.credentials}</p>
          <h2 className="home-question">{t.home.question}</h2>

          <div className="fork-cards">
            <Link to="/ochno" className="fork-card" style={{ backgroundImage: `url(${groupImg})` }}>
              <div className="fork-card-overlay">
                <h3>{t.home.cardATitle}</h3>
                <p className="fork-card-sub">{t.home.cardASub}</p>
                <p className="fork-card-desc">{t.home.cardADesc}</p>
                <span className="fork-card-cta">{t.home.cardACta} →</span>
              </div>
            </Link>

            <Link to="/online" className="fork-card" style={{ backgroundImage: `url(${onlineImg})` }}>
              <div className="fork-card-overlay">
                <h3>{t.home.cardBTitle}</h3>
                <p className="fork-card-sub">{t.home.cardBSub}</p>
                <p className="fork-card-desc">{t.home.cardBDesc}</p>
                <span className="fork-card-cta">{t.home.cardBCta} →</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="home-about-teaser">
        <div className="home-about-teaser-inner">
          <img src={trainerImg} alt="Natalia Nurgalieva" />
          <div>
            <h3>{t.home.aboutTeaserTitle}</h3>
            <ul>
              <li>{t.home.bullet1}</li>
              <li>{t.home.bullet2}</li>
              <li>{t.home.bullet3}</li>
            </ul>
            <Link to="/o-trenere" className="text-link">
              {t.home.aboutMore} →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
